import { usePostPortfolioCryptocurrenciesMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioCryptocurrenciesMutation";
import { CryptocurrenciesProductCategoryKeyEnum } from "web_myplann/Infrastructure/Api/Api";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { getCryptocurrencyCreateFormDefaultValues } from "web_myplann/Portfolio/Forms/CryptocurrencyForm/cryptocurrencyFormDefaults";
import {
	type CryptocurrencyCreateFormOutput,
	getCryptocurrencyCreateFormSchema,
} from "web_myplann/Portfolio/Forms/CryptocurrencyForm/cryptocurrencyFormSchema";
import { mapInvestmentCreateFormToRequest } from "web_myplann/Portfolio/Forms/InvestmentForm/mapInvestmentFormToRequest";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateCryptocurrencyForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioCryptocurrenciesMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getCryptocurrencyCreateFormSchema(t),
		defaultValues: getCryptocurrencyCreateFormDefaultValues(),
		mutate: (data: CryptocurrencyCreateFormOutput, options) => {
			mutate(
				{
					...mapInvestmentCreateFormToRequest(data),
					productCategory:
						CryptocurrenciesProductCategoryKeyEnum.Cryptocurrencies,
				},
				options,
			);
		},
		successRoute: Routing.Portfolio.PortfolioAddCryptocurrencySuccess.path(),
	});

	return { form, onSubmit, isPending };
};
